import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface BoletoVisualizacao {
  boletoId: number;
  pdfBase64: string | null;
  html: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class FinanceiroService {

  private apiUrl = environment.apiPortalPais;

  constructor(private http: HttpClient) { }

  buscarFinanceiro(alunoId: number, anoLetivoId: number): Observable<HttpResponse<any>> {
    return this.http.get(
      `${this.apiUrl}/api/financeiro/aluno/${alunoId}/ano/${anoLetivoId}`,
      { observe: 'response' }
    );
  }

  buscarFinanceiroTodasParcelas(alunoIds: number[], anoLetivoId: number): Observable<HttpResponse<any>> {
    return this.http.post(
      `${this.apiUrl}/api/financeiro/ano/${anoLetivoId}/todas-parcelas`,
      { alunoIds },
      { observe: 'response' }
    );
  }

  visualizarBoletos(boletoIds: number[], alunoIds: number[], anoLetivoId: number): Observable<HttpResponse<BoletoVisualizacao[]>> {
    return this.http.post<BoletoVisualizacao[]>(
      `${this.apiUrl}/api/financeiro/ano/${anoLetivoId}/boletos/visualizar`,
      { boletoIds, alunoIds },
      { observe: 'response' }
    );
  }

  visualizarBoletosTodasParcelas(boletoIds: number[], alunoIds: number[], anoLetivoId: number): Observable<HttpResponse<BoletoVisualizacao[]>> {
    return this.http.post<BoletoVisualizacao[]>(
      `${this.apiUrl}/api/financeiro/ano/${anoLetivoId}/todas-parcelas/boletos/visualizar`,
      { boletoIds, alunoIds },
      { observe: 'response' }
    );
  }

}